import React, { useState } from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import {
  Select,
  SelectValue,
  SelectTrigger,
  SelectContent,
  SelectItem,
} from '~/lib/ui/select'
import { RadioGroup, RadioGroupItem } from '~/lib/ui/radio-group'
import { PaperClip, GreenCheck, RedX } from '../OnboardingSteps/Icons'
import { SpinnerWhite } from '../shared/Spinner'
import { Button } from '~/lib/ui/button'
import { useTranslation } from '../../hooks/useTranslation'

const PartTwoAiForm = () => {
  const { resumes, uiState, setUiState, isDesktop } = usePracticeInterviewing()

  const { t } = useTranslation('PartTwoForm')

  const handleUpdate = (value, type) => {
    setUiState((prev) => ({
      ...prev,
      interviewParams: { ...prev.interviewParams, [type]: value },
    }))
  }
  const resumeChangeEvent = async (event) => {
    setResumeIsUploading(true)
    setUiState((prev) => ({
      ...prev,
      interviewParams: {
        ...prev.interviewParams,
        ['resume_file']: event.target.files[0],
      },
    }))
    setResumeUploadStatus('success')
    setResumeIsUploading(false)
  }
  const resumeFileAcceptList = ['.pdf', '.rtf', '.doc', '.docx', '.txt']
  const [resumeIsUploading, setResumeIsUploading] = useState(false)
  const [resumeUploadStatus, setResumeUploadStatus] = useState('')

  return (
    <div className="flex flex-col pb-8">
      <h2 className="pb-4">{t('title')}</h2>
      <p className="pb-4">{t('description')}</p>
      <div className="flex flex-col pb-4">
        <label htmlFor="resume_id">{t('choose_your_resume')}:</label>
        <div className="flex flex-row">
          <Select
            id="resume_id"
            onValueChange={(value) => handleUpdate(value, 'resume_id')}
            value={
              uiState.interviewParams['resume_id']
                ? uiState.interviewParams['resume_id']
                : ''
            }
          >
            <SelectTrigger>
              <SelectValue
                placeholder={
                  resumes.length < 1
                    ? t('no_saved_resumes')
                    : t('please_choose_a_resume')
                }
              />
            </SelectTrigger>
            <SelectContent>
              {resumes.map((resume, idx) => (
                <SelectItem key={idx} value={resume.id}>
                  {resume.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <div className="m-auto w-8 pl-4">{t('or')}</div>
          <div className="flex flex-row">
            <Button
              onClick={() => {
                document.getElementById('resume-uploader').click()
              }}
              disabled={resumeIsUploading}
              className="ml-4 bg-primary hover:bg-primary-darker-75 disabled:opacity-100 disabled:brightness-75"
            >
              {t('upload_resume')}
              {resumeIsUploading ? (
                <SpinnerWhite className="ml-2" show />
              ) : (
                <PaperClip />
              )}
            </Button>
            {resumeUploadStatus == 'success' && (
              <div className="flex flex-row items-center">
                <span className="ml-4 mr-2">{t('success')}</span> <GreenCheck />
              </div>
            )}
            {resumeUploadStatus == 'failure' && (
              <div className="flex flex-row items-center">
                <span className="ml-4 mr-2">{t('failure')}</span> <RedX />
              </div>
            )}
            <input
              type="file"
              id="resume-uploader"
              accept={resumeFileAcceptList}
              className="!hidden"
              onChange={(event) => resumeChangeEvent(event)}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col pb-8">
        <label htmlFor="questions">{t('number_of_questions')}:</label>
        <Select
          id="questions"
          onValueChange={(value) => handleUpdate(value, 'number_of_questions')}
          value={
            uiState.interviewParams['number_of_questions']
              ? uiState.interviewParams['number_of_questions']
              : 1
          }
          defaultValue={1}
        >
          <SelectTrigger>
            <SelectValue placeholder="Please" />
          </SelectTrigger>
          <SelectContent>
            {Array.from({ length: 10 }, (_, i) => i + 1).map((num, idx) => (
              <SelectItem key={idx} value={num}>
                {num}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex flex-col pb-8">
        <label htmlFor="interview_mode">{t('select_mode')}:</label>
        <p>
          <strong>{t('practice_mode')}</strong> {t('practice_2')}
        </p>
        <p>
          <strong>{t('real_mode')}</strong> {t('real_2')}
        </p>
        <Select
          id="interview_mode"
          onValueChange={(value) =>
            setUiState((prev) => ({
              ...prev,
              practice_mode: value,
            }))
          }
          value={uiState.practice_mode}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={true}>{t('practice')}</SelectItem>
            <SelectItem value={false}>{t('real')}</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {isDesktop && (
        <>
          <label htmlFor="interview_type">{t('type_of_interview')}</label>
          <div className="flex gap-4 pb-4">
            <RadioGroup
              id="interview_type"
              value={uiState.audioInterview}
              onValueChange={(value) =>
                setUiState((prev) => ({ ...prev, audioInterview: value }))
              }
            >
              <label>
                <RadioGroupItem value={false} className="mr-4" />
                {t('video')}
              </label>
              <label>
                <RadioGroupItem value={true} className="mr-4" />
                {t('audio')}
              </label>
            </RadioGroup>
          </div>
        </>
      )}
    </div>
  )
}
export default PartTwoAiForm
